import { $getOpenId, $log, $requestId, $uuid } from './helpers'
import { noop } from './utils'

const VITE_KUAISHOU_APP_ID = import.meta.env.VITE_KUAISHOU_APP_ID

// refs: https://open.kuaishou.com/platform/openApi?group=GROUP_OPEN_PLATFORM&menu=12
export function generateOAuthUrl({ appId = VITE_KUAISHOU_APP_ID, redirect = '', state = '' }) {
  // Note: scope: user_base,business_incentive
  const scope = 'user_base,business_incentive'
  return `https://open.kuaishou.com/oauth2/authorize?app_id=${appId}&scope=${scope}&response_type=code&layoutType=4&bizContainer=ad&redirect_uri=${window.encodeURIComponent(redirect)}&state=${state}`
}

// refs: https://docs.qingque.cn/d/home/eZQCayJ_04C4mUKeID6PSxPU2?identityId=21kSE82Rgsm#section=h.wxai1f7moh07
export const KS = {
  setPhysicalBack: (callback: () => void) => {
    try {
      NeoAdVideoForThirdParty.setPhysicalBack(callback)
    }
    catch (error) {
      $log('KS', 'setPhysicalBack', { error })
    }
  },
  // 0 解锁, 2 图文广告, 3 看广告发金币, 4 视频广告
  // colReadTask 阅读任务, colEnableImageAdVideo 图文广告, colEnableFreeAward 免广告, colEnableFirstAdVideoPop 每日首次广告
  getAdVideo: ({ type = 3, extParams = {} }: { type?: 0 | 2 | 3 | 4; extParams?: any } = {}) => {
    return NeoAdVideoForThirdParty.getAdVideo({
      requestId: $requestId(),
      appId: VITE_KUAISHOU_APP_ID,
      openId: $getOpenId(),
      type,
      extParams,
    })
  },

  // type, 0:看视频解锁, 1:免广告, 2:图文
  // colReadTask 阅读任务, colEnableImageAdVideo 图文广告, colEnableFreeAward 免广告, colEnableFirstAdVideoPop 每日首次广告
  // eslint-disable-next-line @typescript-eslint/ban-types
  playAdVideo({ type = 0, extParams = {}, success = noop, fail = noop }: { type: 0 | 1 | 2 | 3; extParams?: any; success: Function; fail: Function }) {
    return NeoAdVideoForThirdParty.playVideo({
      requestId: $requestId(),
      appId: VITE_KUAISHOU_APP_ID,
      openId: $getOpenId(),
      type,
      extParams,
      success,
      fail,
    })
  },
  // refs: https://docs.qingque.cn/d/home/eZQCayJ_04C4mUKeID6PSxPU2?identityId=21kSE82Rgsm#section=h.wxai1f7moh07
  // show: 素材曝光, startPlay: 开始播放, played3s: 播放3s, played5s: 播放5s, playEnd: 播放结束, playEndPageShow: 播放结束页曝光, replay: 点击重播
  adVideoTrack(sessionId: string, type: 'show' | 'startPlay' | 'played3s' | 'played5s' | 'playEnd' | 'playEndPageShow' | 'replay') {
    try {
      NeoAdVideoForThirdParty.adVideoTrack({
        sessionId,
        adActionType: type,
      })?.catch((error: any) => {
        $log('KS', 'adVideoTrack', { error })
      })
    }
    catch (error: any) {
      $log('KS', 'adVideoTrack', { error })
    }
  },
  adVideoDestroy(sessionId: string) {
    try {
      NeoAdVideoForThirdParty.destroyAdVideo(sessionId)
        ?.catch((error: any) => {
          $log('KS', 'adVideoDestroy', { error })
        })
    }
    catch (error: any) {
      $log('KS', 'adVideoDestroy', { error })
    }
  },
  // refs: https://docs.qingque.cn/d/home/eZQCayJ_04C4mUKeID6PSxPU2?identityId=21kSE82Rgsm#section=h.njxdwoaqvd2q
  // playActionBar: 播放时的actionBar点击, playText: 播放时的text点击, playTitle: 播放时的title点击, cardIcon: 播放时的头像点击, playEndPageBar: 播放结束页的actionBar点击, playEndPageText: 播放结束页的text点击, playEndPageTitle: 播放结束页的title点击, playEndPageIcon: 播放结束页的头像点击,
  openAdVideoDetail(sessionId: string, location = 1, type: 'playActionBar' | 'playText' | 'playTitle' | 'cardIcon' | 'playEndPageBar' | 'playEndPageText' | 'playEndPageTitle' | 'playEndPageIcon' = 'playActionBar') {
    return NeoAdVideoForThirdParty.adVideoConvert({
      sessionId,
      locationType: location,
      itemClickType: type,
    })
  },

  getAdImage: () => {
    return NeoAdVideoForThirdParty.getAdMateria({
      requestId: $requestId(),
      appId: VITE_KUAISHOU_APP_ID,
      openId: $getOpenId(),
      type: 2,
    })
  },
  openAdImageDetail(detailSessionId: string) {
    return NeoAdVideoForThirdParty.clickAdMateria(detailSessionId)
  },
  adImageTrack(detailSessionId: string) {
    return NeoAdVideoForThirdParty.showAdMateria(detailSessionId)
  },
  adImageDestroy(detailSessionId: string) {
    return NeoAdVideoForThirdParty.destroyAdMateria(detailSessionId)
  },
}

if (import.meta.env.MODE === 'development') {
  KS.getAdVideo = () => {
    return Promise.resolve({
      adData: {
        videoUrl: 'https://yuler-static.oss-cn-beijing.aliyuncs.com/6s-video.mp4',
        // videoUrl: 'http://v1.kwaicdn.com/ksc2/wkF49uxS1ljaAeUQyrMpwWOQISYYZiHyes2f04eM_3o4xWTB-xjdNxT7dEn7K8LAgaeIR0UE2AQsSS7yfFLrwxuITimgfd1vHkSsOPGeS2_O880pyQ-uL_gEl6HGsu6U5hb_yyNO_s-b_QZItANu_bo3gT--3Z4nUk380tNaf1wu9WPjNDC15IWgRAIOHG50.mp4?pkey=AAUHmbswTFA2n017XdsP42m0bzEbaJ681OPKyDvzmlJbp5eFUxGN2_exARexFI1i6xBYYcZH5-KlE4rXXvLMBcN3fLZZJF1yT2euVKTXh-9Vcrg7jFTbuw4dlkMua_nk1vo&tag=1-1705905330-unknown-0-qjd71bivry-98814e03a7864064&clientCacheKey=3x8eep74nh8d7ae_b.mp4&di=65285312&bp=10001&tt=b&ss=vp',
        videoDuration: 27300,
        coverImage: 'https://ali-ad.a.yximgs.com/kimg/EMXM1y8qdgoFaW1hZ2USA3BrZxpoYVcxaFoyVXRjR3RuT21Ga1gyUnpjRjlwYldGblpWOTFjR3h2WVdRNk16Z3pNekl3T0RJNE5qcE5SVkpEU0VGT1ZEcGJRa0ExTkdFek1UUmxNam94TlRjek5EVTFNVEF3TWpnMi5qcGc.kpg',
        caption: '传奇手游推荐-经典传世重现-1:1复刻还原-装备靠打！',
        title: '传世狂暴版',
        headIcon: 'https://static.yximgs.com/udata/pkg/d9840108353d4c6bbdcb19af8adc20b3.jpg',
        isDownload: true,
        actionBar: '立即下载',
        actionBarColor: '2d81e5',
      },
      sessionId: $uuid(),
    })
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  KS.playAdVideo = ({ type = 0, success = noop, fail = noop }: { type: 0 | 1 | 2; success: Function; fail: Function }) => {
    // eslint-disable-next-line no-alert
    const confirmed = confirm('DEVELOPMENT: 模拟播放视频')
    if (confirmed)
      success()
    else
      fail()
  }
  KS.adVideoTrack = (sessionId: string, type: string) => {
    $log('KS', '#adVideoTrack', { sessionId, type })
  }
  KS.adVideoDestroy = (sessionId: string) => {
    $log('KS', '#adVideoDestroy', { sessionId })
  }

  KS.getAdImage = () => {
    return Promise.resolve({
      adData: {
        caption: '全新国风仙侠MMO惊喜上线！超高爆率，自由交易能回收！',
        coverUrl: 'https://tx-ad.a.yximgs.com/kimg/EMXM1y8qdgoFaW1hZ2USA3BrZxpoYVcxaFoyVXRjR3RuT21Ga1gyUnpjRjlwYldGblpWOTFjR3h2WVdRNk1qWTROVFV3TnpneU9EcE5SVkpEU0VGT1ZEcGJRa0F6TXpjNU5HTmpORG94TWpjeE1UVXhPVFU1T0RJNC5qcGc.kpg',
        h5Data: JSON.stringify({
          coverUrlFrontend: 'https: //static.yximgs.com/udata/pkg/aW1hZ2UtcGtnOmFkX2RzcF9pbWFnZV91cGxvYWQ6MjY4NTUwNzgyODpNRVJDSEFOVDpbQkAzMzc5NGNjNDoxMjcxMTUxOTU5ODI4.jpg',
          extraDisplayInfo: {
            exposeTag: null,
            showStyle: 0,
            exposeTagInfoList: null,
          },
          privacyInfo: {
            appInfo: {
              appName: '剑魂online',
              appVersion: '1.0.42',
              packageSize: 605623824,
              updateTime: 1705770065908,
              developer: '深圳市无限空间网络技术有限公司',
              appDetailImg: 'https://static.yximgs.com/udata/pkg/85df88c086e94421b3990f97886005ee.jpg',
              appVersionTitle: '版本 1.0.42',
            },
            appPermissions: [],
            privacyPolicyUrl: 'https://37.com.cn/user-agreement/content/?AID=31036',
            functionIntroduction: '这是一个好用的软件',
          },
        }),
      },
      detailSessionId: '15a5097d-9e60-45f4-8227-19710c2b56bd',
    })
  }
}
